import React, {useState, useEffect} from 'react';
import Switch from '@mui/material/Switch';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import {styled} from '@mui/material/styles';
import {editSettingInfo, editSettingTime, getSettingInfo} from "../../apis/user_service";
import {FormControl, MenuItem, Select} from "@mui/material";

const Toggle = styled(Switch)(() => ({
    padding: 6,

    '& .MuiSwitch-track': {
        borderRadius: 52 / 2,
        '&:before, &:after': {
            content: '""',
            position: 'absolute',
            top: '56%',
            transform: 'translateY(-50%)',
            fontSize: '10px',
            color: '#fff',
            width: 16,
            height: 16,
        },
        '&:before': {
            content: '"on"',
            left: 14,
        },
        '&:after': {
            content: '"off"',
            right: 11,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 18,
        height: 18,
        margin: 1,
    },
}));


const pushMenu = [
    {title: '최초보도 알림', subTitle: '최초로 보도된 뉴스를 알려드립니다. 이후 유사한 내용의 뉴스는 알림을 발송하지 않습니다.', key: 'firstnewsalertYN'},
    {title: '단독보도 알림', subTitle: '언론사가 단독으로 보도하는 뉴스를 알려드립니다.', key: 'exclusivenewsalertYN'},
    {title: '모든 뉴스 알림', subTitle: '뉴스가 발생할 때마다 모든 뉴스를 알려드립니다. 몇 개의 반복보도가 있는지 함께 알려드립니다.', key: 'allnewsalertYN'},
    {title: '특정 시간 알림', subTitle: '원하는 시간에만 알림이 발송됩니다.', key: 'statictimeset'},
    {title: '실시간 알림', subTitle: '원하는 시간동안 실시간으로 알림이 발송됩니다.', key: 'realtimeset'},
]
const timeList = [
    '오전12시', '오전1시', '오전2시', '오전3시', '오전4시', '오전5시', '오전6시', '오전7시', '오전8시', '오전9시', '오전10시', '오전11시',
    '오후12시', '오후1시', '오후2시', '오후3시', '오후4시', '오후5시', '오후6시', '오후7시', '오후8시', '오후9시', '오후10시', '오후11시'
]
const SettingPage = () => {

    let alertKeys;
    const [alert, setAlert] = useState(null)//푸시 알림 정보
    const [staticTime, setStaticTime] = useState(null) //특정시간 알림 시간
    const [startTime, setStartTime] = useState(null) // 실시간 알림 시작시간
    const [endTime, setEndTime] = useState(null) // 실시간 알림 종료시간

    useEffect(() => {
        getSettingInfo().then(res => {
            setAlert(res)
            setStaticTime(res.statictimeset.alertstarttime)
            setStartTime(res.realtimeset.alertstarttime)
            setEndTime(res.realtimeset.alertendtime)
            alertKeys = Object.keys(res)

        })
    }, [])

    const toggleClick = (idx, state) => {
        const type = '0' + (idx + 1) // 01 : 최초보도, 02 : 단독보도, 03 : 모든 뉴스
        const status = state === 'Y' ? 'N' : 'Y' // 허용 여부 (Y : 켬 / N : 끔)
        editSettingInfo(type, status).then(res => console.log(res))
    }


    const pushTimeSetting = (type, status) => {
        editSettingTime(type, status ).then(res => console.log(res))
    }

    return (
        <div className='setting container'>
            <div className=' setting_container'>
                <p className='title_lg'>웹 알림 설정</p>
                {!!alert &&
                    <List >
                        {pushMenu.slice(0, 3).map((menu, idx) => {
                                const toggle = menu.key
                                return (
                                    <div className='list_container' key={idx}>
                                        <ListItem className='setting_list'>
                                            <ListItemText primary={menu.title} secondary={menu.subTitle}/>
                                        </ListItem>
                                        <Toggle onClick={() => toggleClick(idx, alert[toggle])}
                                                defaultChecked={alert[toggle] === 'Y'}/>
                                        <Divider component="li"/>
                                    </div>
                                )
                            }
                        )}

                        <div  className='list_container'>
                            <ListItem className='setting_list'>
                                <ListItemText primary={pushMenu[3].title} secondary={pushMenu[3].subTitle}/>
                            </ListItem>
                            <FormControl sx={{m: 1, width: 150}}>
                                <Select value={staticTime} className='select_input' onChange={(e)=>setStaticTime(e)} >
                                    {timeList.map(time => <MenuItem key={time} value={time}>{time}</MenuItem>)}
                                </Select>
                            </FormControl>
                            <Toggle defaultChecked={alert.statictimeset !== null && alert.statictimeset.agree === 'Y' }/>
                            <Divider component="li"/>
                        </div>

                        <div  className='list_container'>
                            <ListItem className='setting_list'>
                                <ListItemText primary={pushMenu[4].title} secondary={pushMenu[4].subTitle}/>
                            </ListItem>

                                <Select value={startTime}
                                        className='select_input'
                                        onChange={(e)=> {
                                            setStartTime(e)
                                        }}
                                >
                                    {timeList.map(time => <MenuItem key={time} value={time}>{time}</MenuItem>)}
                                </Select>
                                <Select value={endTime}
                                        className='select_input'
                                        onChange={(e)=> {
                                            setEndTime(e)

                                        }}
                                >
                                    {timeList.map(time => <MenuItem key={time} value={time}>{time}</MenuItem>)}
                                </Select>

                            <Toggle defaultChecked={alert.realtimeset !== null && alert.realtimeset.agree === 'Y' }/>
                        </div>
                    </List>}
            </div>
        </div>
    );
};

export default SettingPage;